// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { connect } from 'react-redux';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import TopLevelNavLink from '../menus/TopLevelNavLink';
import type { NavLinkType } from '../types';
import styles from './SideBarNavItem.less';

type ExternalProps = {|
  /** A navigation link to display in the side bar */
  link: NavLinkType,
  /** True if the link should be displayed with its corresponding icon */
  showIcon?: boolean,
  /** True if the the nav item should have white text (settings/signout button have black background and white text) */
  hasWhiteText?: boolean,
  /** Whether have sub items */
  hasSubItem?: boolean,
  /** Callback for expanding item */
  expandLinks?: (subLinks: NavLinkType[], e: SyntheticEvent<*>) => void,
|};

type Props = {|
  ...ExternalProps,
  /** The name of the current servlet, used for tracking purposes */
  servletName: string,
|};

/** Component that wraps TopLevelNavLink, providing it with custom side-bar classes. */
const SideBarNavItem = ({
  link,
  showIcon,
  hasWhiteText,
  servletName,
  hasSubItem,
  expandLinks,
}: Props) => {
  const containerClasses = classNames(styles.navItem, {
    [styles.hasWhiteText]: hasWhiteText, // sets the border color to white
  });
  const navLinkClasses = classNames(styles.link, {
    [styles.hasWhiteText]: hasWhiteText, // sets the text color in the nav item to white
  });
  const trackingModule = `TopNav_${servletName}`;
  let labelElement;

  if (link.promoteAsNew) {
    labelElement = <span className={styles.newLabel}>{localize('common_NEW_1bd8')}</span>; // NEW
  }

  if (hasSubItem) {
    labelElement = (
      <span
        onClick={e => {
          if (expandLinks) {
            expandLinks(link.subList, e);
          }
        }}
      >
        <Icon className={styles.subItemIndicator} name="single-chevron-right" />
      </span>
    );
  }
  return (
    <li className={containerClasses}>
      <TopLevelNavLink
        link={link}
        extraClasses={navLinkClasses}
        quickLinkIconClasses={styles.navIcon}
        showQuickLinkIcon={showIcon}
        trackingModule={trackingModule}
        extraLabel={labelElement}
        nonLink={link?.id === 'tourism' || link?.id === 'scoped-home'}
      />
    </li>
  );
};

/** These are defaulted to false because most items in the sidebar do not have these properties */
SideBarNavItem.defaultProps = {
  showIcon: false,
  hasWhiteText: false,
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  servletName: state.meta.initialServletName,
}))(SideBarNavItem);
